<p-calendar
    #calendar
    (ngModelChange)="showTime ? (this.date = $event) : changeDateTime($event, 'inside')"
    [baseZIndex]="1060"
    [dataType]="stringify ? 'string' : 'date'"
    [firstDayOfWeek]="1"
    [hideOnDateTimeSelect]="!showTime"
    [inline]="inline"
    [inputId]="timeId"
    [inputStyleClass]="hiddenCalendar ? 'hidden-calendar' : ''"
    [minDate]="minDate"
    [ngModel]="isRange ? rangeDates : date"
    [readonlyInput]="isRange"
    [selectionMode]="isRange ? 'range' : 'single'"
    [showButtonBar]="isRange"
    [showTime]="showTime"
    [styleClass]="hiddenCalendar ? 'hidden-calendar' : ''" appendTo="body"
    dateFormat="yy-mm-dd">
    <ng-template *ngIf="showTime" pTemplate="footer">
        <button (click)="changeDateTime(date, 'inside')" class="btn btn-block btn-success">
            <span>{{ "BUTTON_TEXT.ONLY_SAVE" | translate }}</span>
        </button>
    </ng-template>
</p-calendar>
